export default {
    isAuth: (state) => {
        return state.userState.auth != null;
    },
    getAuthUser: (state) => {
        return state.userState.auth;
    },
    getJWTToken: (state) => {
        return state.userState.token;
    },
    getAuthUserRoleName: (state) => {
        return state.userState.role_name;
    },
    getAuthUserPermissions: (state) => {
        return state.userState.permissions;
    },
    loginLoading: state => state.userState.loginLoading,

    getQuotations: (state) => {
        return state.quotationState.quotations;
    },
    getQuotationsLoading: state => state.quotationState.quotationsLoading,
    newQuotation: state => state.quotationState.newQuotation,
    priceCalculation: state => state.quotationState.priceCalculation,
    quotationFilters: state => state.quotationState.filter,


    errorMessage: state => state.commonState.errorMessage,
    successMessage: state => state.commonState.successMessage,
    commonErrors: state => state.commonState.commonErrors,
    exportFile: state => state.commonState.exportFile,
    loading: state => state.commonState.loading,
    productsLoading: state => state.commonState.productsLoading,
    quoteProductsLoading: state => state.commonState.quoteProductsLoading,
    settings: state => state.commonState.settings,
    getDashboardTarget: state => state.commonState.dashboardTarget,
    getDashboardTargetUser: state => state.commonState.dashboardTargetUser,
    carriersState: state => state.commonState.carriers,
    vendorFilter: state => state.commonState.vendorFilter,

    customers: state => state.customerState.customers,
    customersLoading: state => state.customerState.customersLoading,


    getSalesOrderState: (state) => {
        return state.salesOrderState;
    },
    orders: state => state.salesOrderState.orders,
    ordersLoading: state => state.salesOrderState.ordersLoading,
    maxNumOfShipToAddress: state => state.salesOrderState.maxNumOfShipToAddress,
    newOrder: state => state.salesOrderState.newOrder,
    salesOrderMenuItems: state => state.salesOrderState.menuItems,

    getPurchaseOrderState: (state) => {
        return state.purchaseOrderState;
    },
    purchaseOrders: state => state.purchaseOrderState.orders,
    purchaseOrdersLoading: state => state.purchaseOrderState.ordersLoading,
    newPurchaseOrder: state => state.purchaseOrderState.newOrder,
    purchaseOrderMenuItems: state => state.purchaseOrderState.menuItems,
    shipmentBackProduct: state => state.backState.loading,

};
